// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__0CpsJ","fadeIn":"styles_fadeIn__PkeE3"};